import { ref } from '@nuxtjs/composition-api';
import { useVSFContext } from '@vue-storefront/core';

import getVehiclesByRego from './getVehiclesByRego';
import { computed } from '@nuxtjs/composition-api';
import {
  UseRegoSearchError,
  UseRegoSearchLoading,
  UseRegoSearchResult,
} from '@composables/src/useRegoSearch/types';

const useRegoSearch = () => {
  const context = useVSFContext();
  const loading = ref(false);
  const result = ref(null);
  const error = ref(null);

  const refs = {
    loading,
    result,
    error,
  };

  return {
    getVehiclesByRego: getVehiclesByRego(context, refs),
    result: computed<UseRegoSearchResult>(() => result.value),
    loading: computed<UseRegoSearchLoading>(() => loading.value),
    error: computed<UseRegoSearchError>(() => error.value),
  };
};

export default useRegoSearch;
